export const DAY_VIEW = {
  HEADER_TYPE: {
    FULL: 'full',
    MINI: 'mini',
    CLOSE: 'close',
  }
}
